"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gateway response from either adding or updating a service.
 */
var AddUpdateServiceResponse = /** @class */ (function () {
    /**
     * Create a new AddUpdateServiceResponse instance
     * @param type the response type
     * @param service the returned service
     */
    function AddUpdateServiceResponse(type, service) {
        this.type = type;
        this.service = service;
    }
    return AddUpdateServiceResponse;
}());
exports.AddUpdateServiceResponse = AddUpdateServiceResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/add-update-service-response.js
// module id = 1290
// module chunks = 1